// @ts-nocheck
import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";
import Pagination, { PaginationPresentationProps } from "@store/MobiusOverrides/Pagination/Pagination";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
import React from "react";
import { css } from "styled-components";

interface DataTablePaginationStyles {
    cssOverrides: PaginationPresentationProps["cssOverrides"];
}

const dataTablePaginationStyles: DataTablePaginationStyles = {
    cssOverrides: {
        perPageSelect: css`
            display: show;
        `,
        pagination: css`
            display: flex;
            flex-direction: column;
            gap: ${pxToRem(16)};
            margin: ${pxToRem(32)} !important;
            align-self: center;
        `,
    },
};
interface Props {
    resultsCount: number;
    resultsPerPage: number;
    onChangeResultsPerPage: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    onChangePage: (newPageNumber: number) => void;
    currentPage: number;
    styles?: DataTablePaginationStyles;
}
const DataTablePagination: React.FC<Props> = ({
    resultsCount,
    resultsPerPage,
    onChangePage,
    onChangeResultsPerPage,
    currentPage,
    styles,
}) => {
    const { cssOverrides } = useMergeProps(dataTablePaginationStyles, styles);
    return (
        <Pagination
            resultsPerPageLabel="Results Per Page"
            resultsCount={resultsCount}
            resultsPerPage={resultsPerPage}
            resultsPerPageOptions={[10, 25, 50, 100]}
            onChangeResultsPerPage={onChangeResultsPerPage}
            currentPage={currentPage}
            onChangePage={onChangePage}
            mergeCss
            cssOverrides={cssOverrides}
        />
    );
};

export default DataTablePagination;
